import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRssComponent } from './simple-icons-rss.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRssComponent ],
    exports:      [ SimpleIconsRssComponent ],
    bootstrap:    []
})
export class SimpleIconsRssModule {}
